export default class ExamState {
  public currentAreaKey: number | string = 0;
}
